import React from 'react'
import { formatTripName } from 'AccountsUtils'
import CalendarIcon from '../CalendarIcon'
import './TripLabel.css'

const TripLabel = ({ tripDetails }) => {
  if (tripDetails) {
    const iconClass = tripDetails.verticalName
    return (
      <React.Fragment>
        <div className="trip-label flex apl-10 apr-10 mb-0 mt-0">
          <CalendarIcon dateStr={tripDetails.travelDate} />
          <span className={`trip-icon ${iconClass || tripDetails.tripType}-icon`} />
          <div className="tripname-travellers">
            <h3 className="support-truncate apb-5 apt-5 apl-5 apr-5" title={formatTripName(tripDetails)}>
              {formatTripName(tripDetails)}
            </h3>
            <small className="support-truncate fs-12 c-black-50 apl-5 apr-5" title="">
              {tripDetails.travellers || tripDetails.traveller}
            </small>
          </div>
        </div>
      </React.Fragment>
    )
  }
  return null
}

export default TripLabel
